import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=771002cc&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=js&"
export * from "./Process.vue?vue&type=script&lang=js&"
import style0 from "@/less/service.less?vue&type=style&index=0&id=771002cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771002cc",
  null
  
)

export default component.exports